import { useEffect, useState } from "react";

function SplashScreen() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {showSplash  ? (
        <div className="splash-screen">
          <svg
            viewBox="0 0 395.58 357.76"
            xmlns="http://www.w3.org/2000/svg"
            className="splash-logo"
          >
            <path
              d="M338.32,40.65l-1.77-.12c-18.33-1.31-43.44-.85-72.51-.32C181.85,41.72,69.27,43.78,10.8,6.76L.13,0,0,12.63C0,17.8-.42,140.24,68.56,222.37c27.26,32.46,67.44,51,110.5,51h1.85c73.91-.92,127,7.61,149.62,24,41.9,30.4,50.08,56.9,51,60.44l14-14.05V76.9Zm43.2,286.83c-8.4-11.79-21.72-26.3-42.73-41.55-30-21.76-94.6-26.73-147.35-26.73q-5.44,0-10.7.06l-1.67,0c-38.89,0-75.17-16.69-99.74-46-2.81-3.34-5.47-6.78-8-10.27,20.54,10.18,43.65,13.08,73.34,9.78,5.9-.65,12.05-1.47,18.57-2.33,51.91-6.86,122.51-16.17,185.7,43V234.74c-65.28-54.34-135.38-45.08-187.55-38.18-6.44.85-12.52,1.65-18.27,2.29-40,4.45-65.58-2.92-90.67-26.16-13.33-25.44-22-52.28-27.71-76.57.66.69,1.31,1.38,2,2.07,15.18,15,42.89,32.61,89,31.46,10.27-.26,22.49-1.63,36.64-3.21,57.06-6.39,142.47-15.92,196.55,42.46V149.17c-58.56-52.31-141.58-43-198.11-36.71C137,114,125,115.34,115.36,115.58,42.16,117.5,21,68.64,18.09,61,15.94,46,14.93,33.52,14.46,25c64,32.68,170.68,30.72,249.83,29.27,27.8-.51,51.93-1,69.51.17l47.72,30.21Z"
              fill="none"
              stroke="#cfad5d"
              strokeWidth="5"
            />
          </svg>
        </div>
      ) : (
        false
      )}
    </>
  );
}

export default SplashScreen;
